/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RevokeTokenRequest as DigiworkMaitreDDtoAuthenticationRevokeTokenRequest } from '../../models/Digiwork/MaitreD/DTO/Authentication/revoke-token-request';

export interface RevokeToken$Params {
      body?: DigiworkMaitreDDtoAuthenticationRevokeTokenRequest
}

export function revokeToken(http: HttpClient, rootUrl: string, params?: RevokeToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, revokeToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

revokeToken.PATH = '/api/wtr/User/signout';
